import { useMemo } from "react";

export function useMuseImageUrl(
  coverImage: { isMuseImage?: boolean; url?: string } | undefined,
  fallbackImageUrl: string | undefined,
  imageSize: number
) {
  return useMemo(() => {
    if (coverImage?.isMuseImage && coverImage.url) {
      const imageUrl = `${coverImage.url}&_width=${imageSize * 2}`;
      const srcSet = [
        `${coverImage.url}&_width=${imageSize}`,
        `${coverImage.url}&_width=${imageSize * 1.5} 1.5x`,
        `${coverImage.url}&_width=${imageSize * 2} 2x`,
      ].join(", "); // Join with a single space to ensure the proper format
      return { imageUrl, srcSet };
    }
    return { imageUrl: fallbackImageUrl, srcSet: fallbackImageUrl };
  }, [coverImage?.isMuseImage, coverImage?.url, imageSize, fallbackImageUrl]);
}
